import { z } from 'zod';

/**
 * Single source of truth for LLM provider names. Both the
 * `agent-config` family of schemas (full LLM settings, fallback chain
 * entries) and the `voice-stack` resolved-stack schema reuse this.
 * Adding a provider = one edit here.
 *
 * OpenAI-compatible endpoints (groq, together, fireworks) are folded
 * into the same builder path in `apps/livekit/src/providers/llm.ts`
 * via per-provider `baseURL` lookup; their distinction is purely a
 * routing concern, not a behavioral one at the schema level.
 */
export const LLM_PROVIDERS = z.enum([
  'openai',
  'anthropic',
  'google',
  'groq',
  'together',
  'fireworks',
]);

export type LlmProvider = z.infer<typeof LLM_PROVIDERS>;
